import { render, staticRenderFns } from "./CreditForBusiness.vue?vue&type=template&id=ab787180&scoped=true"
import script from "./CreditForBusiness.vue?vue&type=script&lang=ts"
export * from "./CreditForBusiness.vue?vue&type=script&lang=ts"
import style0 from "./CreditForBusiness.vue?vue&type=style&index=0&id=ab787180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab787180",
  null
  
)

export default component.exports